import Hero from "../Hero";
import Credibility from "../Creadiblity";
// import State from "../State";
import ConnectedServices from "../ConnectedServices";
import SocialProof from "../SocialProof";
import Cta from "../Cta";
import AboutCTA from "../AboutCTA";
import "../../styles/Home.css";
import { usePageEffects } from "../usePageEffects";
import BlogCards from "../BlogCards";
import CaseStoryGrid from "../CaseStoryGrid";
import BrandLogoMarquee from "../BrandLogoMarquee";
import SEO, { localBusinessSchema } from "../SEO";
import { Swords, BarChart2, ClipboardList, Gauge } from "lucide-react";

export default function Home() {
  const items = [
    {
      icon: <Swords size={24} />,
      title: "TechTCL vs Others",
      desc: "See how we compare to freelancers & big agencies",
      link: "/compare",
      color: "#2563eb",
    },
    {
      icon: <BarChart2 size={24} />,
      title: "ROI Calculator",
      desc: "Calculate how much revenue we can add to your store",
      link: "/roi-calculator",
      color: "#065f46",
    },
    {
      icon: <ClipboardList size={24} />,
      title: "Our Process",
      desc: "What happens after you hire us — 7 transparent steps",
      link: "/our-process",
      color: "#7c2d12",
    },
    {
      icon: <Gauge size={24} />,
      title: "Free Speed Test",
      desc: "Test your Shopify store's speed — get PageSpeed score instantly",
      link: "/speed-test",
      color: "#9f1239",
    },
  ];

  usePageEffects();
  return (
    <div className="homepage_wrapper">
      <SEO
        title="Certified Shopify Growth Partner"
        description="TechTCL is a certified Shopify growth partner delivering premium e-commerce development, CRO optimization, and custom solutions. 150+ projects, 100% client satisfaction across 15+ countries."
        path="/"
        schema={localBusinessSchema}
      />
      <Hero />
      <BrandLogoMarquee />
      <Credibility />
      {/* <State /> */}
      <ConnectedServices />
      <SocialProof />
      {/* <Case /> */}
      <CaseStoryGrid />
      <Cta />
      {/* <Blog />   */}

      {/* Quick Resource Links */}
      <section style={{ padding: "60px 20px", background: "#f9fafb" }}>
        <div
          style={{
            maxWidth: 1100,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: 16,
          }}
        >
          {items.map((item, i) => (
            <a
              key={i}
              href={item.link}
              style={{
                background: "#fff",
                borderRadius: 14,
                padding: "24px 20px",
                textDecoration: "none",
                border: "1px solid #f0f0f0",
                transition: "all .3s",
                display: "block",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,.06)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "";
                e.currentTarget.style.boxShadow = "";
              }}
            >
              <div style={{ fontSize: 28, marginBottom: 10 }}>{item.icon}</div>
              <h3
                style={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: "#1a1a1a",
                  marginBottom: 4,
                }}
              >
                {item.title}
              </h3>
              <p
                style={{
                  fontSize: 13,
                  color: "#888",
                  lineHeight: 1.5,
                  marginBottom: 8,
                }}
              >
                {item.desc}
              </p>
              <span
                style={{ fontSize: 13, fontWeight: 600, color: item.color }}
              >
                Explore →
              </span>
            </a>
          ))}
        </div>
      </section>

      <BlogCards />
      <AboutCTA />
    </div>
  );
}
